var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconImplementationExamples(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-implementation-examples-01 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,8H5A3,3,0,0,1,8,5H8",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.21,5H16a3,3,0,0,1,3,3v8",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,13.21V16a3,3,0,0,0,3,3h8",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.47,13.47a6,6,0,0,1-3.88.37A6,6,0,0,1,2.16,9.41a6,6,0,0,1,.37-3.88L6.29,9.29a1,1,0,0,0,1.42,0L9.29,7.71a1,1,0,0,0,0-1.42L5.53,2.53a6,6,0,0,1,3.88-.37,6,6,0,0,1,4.43,4.43,6,6,0,0,1-.37,3.88",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.47,10.47,21,18a2.12,2.12,0,0,1-3,3l-7.53-7.53",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconImplementationExamples);
export default __webpack_public_path__ + "static/media/navigation-icon-implementation-examples.27493ab13238e005c2b11c193b23dc60.svg";
export { ForwardRef as ReactComponent };